import {
    resetMoneyEntriesFetch,
    resetOrdersFetch,
    setCreateOrderStatus,
} from "actions/balance";
import { fetchUser } from "actions/user";
import { put, takeLeading } from "redux-saga/effects";
import handleNetworkError from "sagas/helpers/handleNetworkError";
import { post } from "sagas/helpers/network";

function* execute(action: sage.actions.balance.ICreateOrder) {
    if (
        isNaN(action.priceCentHundredths) ||
        action.priceCentHundredths <= 0 ||
        isNaN(action.minutes) ||
        action.minutes <= 0
    ) {
        yield put(setCreateOrderStatus("request_parse_error"));
        return;
    }
    yield put(setCreateOrderStatus("loading"));
    try {
        const response = yield post("/create-order", {
            minutes_ordering: action.minutes,
            price_cents_hundredths: action.priceCentHundredths,
        });
        if (response.data !== null) {
            yield put(setCreateOrderStatus("success"));
            yield put(fetchUser());
            yield put(resetOrdersFetch());
            yield put(resetMoneyEntriesFetch());
        } else {
            yield put(setCreateOrderStatus("error"));
        }
    } catch (e) {
        const errCode = e.response && e.response.data && e.response.data.error;
        if (errCode === "REQUEST_PARSE_ERROR") {
            yield put(setCreateOrderStatus("request_parse_error"));
        } else if (errCode === "INSUFFICIENT_FUNDS_ERROR") {
            yield put(setCreateOrderStatus("insufficient_funds"));
        } else if (errCode === "CONFLICT_ERROR") {
            yield put(setCreateOrderStatus("conflict"));
        } else {
            yield put(setCreateOrderStatus("error"));
        }
        yield handleNetworkError(e);
    }
}

export default function* saga(): Generator {
    yield takeLeading("com.sage.actions.balance.ICreateOrder", execute);
}
